import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { ComingSoonPreview } from 'types/comingSoonFeatures';

const PreviewCards = styled.div`
  position: relative;
  flex: 1 1 340px;
  min-width: min(340px, 100%);
  max-width: 490px;
  height: 180px;
  color: var(--text-primary);

  @media (max-width: 600px) {
    display: none;
  }
`;

const PreviewCard = styled.div`
  position: absolute;
  box-sizing: border-box;
  width: min(280px, 100%);
  padding: 16px 20px;
  border-radius: 8px;
  background: var(--white);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

  &.back {
    top: 10px;
    left: 0;
    transform: rotate(-4deg);
  }

  &.front {
    top: 30px;
    right: 0;
    transform: rotate(4deg);
  }

  .value {
    font-family: var(--font-bold);
    font-size: 24px;
  }

  .bar {
    height: 3px;
    margin-top: 6px;
    border-radius: 2px;
  }

  .gold {
    background: var(--negative-orange);
  }

  .green {
    background: var(--positive-green);
  }

  .meta {
    margin-top: 10px;
    font-size: 12px;
  }

  .blue {
    color: var(--competitor-purple);
  }

  .orange {
    color: var(--negative-orange);
  }
`;

const PreviewLabel = styled.div`
  font-size: 12px;
  text-transform: uppercase;
`;

const PreviewValueRow = styled.div`
  margin-top: 6px;
`;

const PreviewCardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-bold);
  font-size: 18px;

  img {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
  }
`;

const PreviewCardText = styled.div`
  margin-top: 8px;
  line-height: 1.4;
`;

type Props = {
  preview: ComingSoonPreview;
};

const ComingSoonPreviewCards = ({ preview }: Props) => (
  <PreviewCards>
    <PreviewCard className="back">
      <PreviewLabel>{preview.label}</PreviewLabel>
      <PreviewValueRow>
        <span className="value">{preview.value}</span> {preview.suffix}
      </PreviewValueRow>
      <div className={classNames('bar', preview.barClassName)} />
    </PreviewCard>
    <PreviewCard className="front">
      <PreviewCardTitle>
        <img src="/icons/ai-blob.svg" alt="" />
        {preview.cardTitle}
      </PreviewCardTitle>
      <PreviewCardText>{preview.cardText}</PreviewCardText>
      <div className={classNames('meta', preview.metaClassName)}>{preview.cardMeta}</div>
    </PreviewCard>
  </PreviewCards>
);

export default ComingSoonPreviewCards;
